import React from "react";

/**
 * Props that can be passed to any step component in the workflow
 */
export interface PayableStepProps {
  onExit?: () => void;
  onComplete?: (paymentBatchId: string) => void;
}

/**
 * Workflow step type for StepIndicator and step rendering
 */
export type PayableStepComponent = React.FC<PayableStepProps>;

export type PayableWorkflowStepConfig = {
  index: number;
  name: string;
  url: string;
  status: "active" | "complete" | "inactive";
  component: PayableStepComponent;
};

export const StepNames = {
  Client: "Client and payee details",
  PaymentDetails: "Payment details",
} as const;
